import { __extends, __rest, __assign } from 'tslib';
import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import { UitkField } from 'uitk-react-field';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-input.css';
var getClassNameList = classNames.bind(styles);
var Input = /** @class */function (_super) {
  __extends(Input, _super);
  function Input(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      autofilled: false,
      mounted: false
    };
    _this.handleClear = _this.handleClear.bind(_this);
    _this.setAutoFill = _this.setAutoFill.bind(_this);
    _this.inputRef = props.domRef || React.createRef();
    return _this;
  }
  Input.prototype.componentDidMount = function () {
    this.startTimer();
    this.setState({
      mounted: true
    });
  };
  Input.prototype.componentWillUnmount = function () {
    var domRef = this.props.domRef;
    if (domRef) {
      this.clearTimer();
    }
  };
  Input.prototype.handleClear = function () {
    var _a, _b;
    var _c = this.props,
      handleClear = _c.handleClear,
      onChange = _c.onChange,
      id = _c.id,
      name = _c.name;
    if (onChange) {
      onChange({
        target: {
          value: '',
          name: name !== null && name !== void 0 ? name : id
        }
      });
      // Shift focus back to input field for a11y
      (_b = (_a = this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
    }
    if (typeof handleClear === 'function') {
      handleClear();
    }
  };
  Input.prototype.setAutoFill = function () {
    var _a;
    var curr = (_a = this.inputRef) === null || _a === void 0 ? void 0 : _a.current;
    if (curr) {
      try {
        if (curr.matches(':autofill')) {
          this.clearTimer();
          this.setState({
            autofilled: true
          });
        }
      } catch (error) {
        try {
          if (curr.matches(':-webkit-autofill')) {
            this.clearTimer();
            this.setState({
              autofilled: true
            });
          }
          // eslint-disable-next-line @typescript-eslint/no-shadow
        } catch (error) {
          return false;
        }
      }
    }
  };
  Input.prototype.startTimer = function () {
    var _this = this;
    // Before init setTimeout, clear the existing timer
    this.clearTimer();
    this.autofillInput = setTimeout(function () {
      _this.setAutoFill();
    }, 500);
  };
  Input.prototype.clearTimer = function () {
    clearTimeout(this.autofillInput);
  };
  Input.prototype.render = function () {
    // Black list these props from the input field
    var _a = this.props,
      children = _a.children,
      className = _a.className,
      label = _a.label,
      hasBorder = _a.hasBorder,
      hasFloatedLabel = _a.hasFloatedLabel,
      hasVisibleLabel = _a.hasVisibleLabel,
      icon = _a.icon,
      instruction = _a.instruction,
      invalid = _a.invalid,
      l10n = _a.l10n,
      hasClearButton = _a.hasClearButton,
      required = _a.required,
      attributes = __rest(_a, ["children", "className", "label", "hasBorder", "hasFloatedLabel", "hasVisibleLabel", "icon", "instruction", "invalid", "l10n", "hasClearButton", "required"]);
    var placeholder = attributes.placeholder,
      attrs = __rest(attributes, ["placeholder"]);
    var id = attributes.id,
      disabled = attributes.disabled,
      readOnly = attributes.readOnly,
      value = attributes.value;
    var _b = this.state,
      autofilled = _b.autofilled,
      mounted = _b.mounted;
    var showClearButton = mounted && hasClearButton && value;
    var fieldPropsClassNames = getClassNameList(showClearButton && 'has-input-cta');
    var fieldProps = {
      labelClassName: fieldPropsClassNames,
      disabled: disabled,
      hasAutofill: autofilled,
      hasBorder: hasBorder,
      hasFloatedLabel: hasFloatedLabel,
      hasVisibleLabel: hasVisibleLabel,
      icon: icon,
      id: id,
      instruction: instruction,
      invalid: invalid,
      label: label,
      placeholder: placeholder,
      readOnly: readOnly,
      required: required
    };
    var inputExtraAttr = attrs;
    if (inputExtraAttr.domRef) {
      delete inputExtraAttr.domRef;
    }
    if (inputExtraAttr.handleClear) {
      delete inputExtraAttr.handleClear;
    }
    var cssClassNames = getClassNameList('uitk-field-input', showClearButton && 'has-input-cta', className, !placeholder && !(value === null || value === void 0 ? void 0 : value.toString()) && 'empty-placeholder');
    var ariaFieldLabel = label;
    if (React.isValidElement(label)) {
      var labelProp = label.props;
      ariaFieldLabel = labelProp && labelProp.children && labelProp.children[0];
    }
    var localizedClearText = l10n.formatText('clear');
    var iconTitle = [localizedClearText, ariaFieldLabel].join(' ');
    return React.createElement(UitkField, __assign({}, fieldProps), React.createElement("input", __assign({}, inputExtraAttr, {
      className: cssClassNames,
      "aria-describedby": invalid ? "".concat(id, "-error") : undefined,
      placeholder: placeholder,
      ref: this.inputRef,
      id: id,
      "aria-required": required,
      "aria-invalid": !!invalid
    })), children, showClearButton && mounted && React.createElement("button", {
      className: getClassNameList('uitk-clear-button', 'uitk-input-cta'),
      onClick: this.handleClear,
      type: "button"
    }, React.createElement(UitkIcon, {
      name: "cancel",
      size: UitkIconSize.SMALL,
      title: iconTitle,
      id: "".concat(id, "-clear-input-button")
    })));
  };
  Input.defaultProps = {
    hasClearButton: false,
    required: false,
    value: ''
  };
  return Input;
}(React.Component);
var UitkInput = function (props) {
  var l10n = useLocalization();
  return React.createElement(Input, __assign({
    l10n: l10n
  }, props));
};
export { UitkInput };